import { Box, Grid, GridItem, Heading, useToast } from "@chakra-ui/react";
import Dataset from './Dataset';
import DatasetOttenuti from './DatasetOttenuti';
import Risultati from "./Risultati";
import Elaborazioni from "./Elaborazioni";
import { useEffect, useState } from "react";
import StagingArea from "./StagingArea";
//import { useSession } from '../SessionContext';
//  import  {prova_variabile} from '../config';
//import BGImage from './BgImage.jpg';
import DatasetPubblici from './DatasetPubblici';
import { useTranslation } from "react-i18next";
//Publisher Components
import NewUsersList from "../components/UserManagement/NewUsersList";
import DeletedUserList from "../components/UserManagement/DeletedUsersList";
import ToDeprecateDatasetList from "../components/UserManagement/ToDeprecateDatasetList";
import DeprecatedDatasetList from "../components/UserManagement/DeprecatedDatasetList";

export default function Home() {
  const toast = useToast();
  const { t } = useTranslation();

  // User Role State
  const [userRole, setUserRole] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const role = sessionStorage.getItem("role") ?? "";
    console.log("User role:", role);
    setUserRole(role);
    setIsLoading(false);
  }, []);

  // Show loading state while determining user role
  if (isLoading) {
    return (
      <Box h="100vh" w="100%" bgColor={"#f6f3ec"} display="flex" alignItems="center" justifyContent="center">
        <Heading>Loading...</Heading>
      </Box>
    );
  }

  // Publisher Layout
  // if (userRole === "Publisher") {
  //   return (
  //     <Box h="100vh" w="100%" bgColor={"#f6f3ec"} overflow="hidden">
  //       <Grid
  //         templateRows='repeat(2, 1fr)'
  //         templateColumns='repeat(4, 1fr)'
  //         h='100%'
  //         w='100%'
  //         gap={2}
  //         p={2}
  //       >
  //         <GridItem colSpan={2} h="100%">
  //           <Box
  //             h="100%"
  //             borderWidth={2}
  //             borderColor={"#0888BE"}
  //             borderRadius={"20px"}
  //             bgColor={"#f6f3ec"}
  //             p="10px"
  //             display="flex"
  //             flexDirection="column"
  //             overflow="hidden"
  //           >
  //             <NewUsersList />
  //           </Box>
  //         </GridItem>
  //         <GridItem colSpan={2} h="100%">
  //           <Box
  //             h="100%"
  //             borderWidth={2}
  //             borderColor={"#0888BE"}
  //             borderRadius={"20px"}
  //             bgColor={"#f6f3ec"}
  //             p="10px"
  //             display="flex"
  //             flexDirection="column"
  //             overflow="hidden"
  //           >
  //             <DeletedUserList />
  //           </Box>
  //         </GridItem>
  //         <GridItem colSpan={2} h="100%">
  //           <Box
  //             h="100%"
  //             borderWidth={2}
  //             borderColor={"#0888BE"}
  //             borderRadius={"20px"}
  //             bgColor={"#f6f3ec"}
  //             p="10px"
  //             display="flex"
  //             flexDirection="column"
  //             overflow="hidden"
  //           >
  //             <ToDeprecateDatasetList />
  //           </Box>
  //         </GridItem>
  //         <GridItem colSpan={2} h="100%">
  //           <Box
  //             h="100%"
  //             borderWidth={2}
  //             borderColor={"#0888BE"}
  //             borderRadius={"20px"}
  //             bgColor={"#f6f3ec"}
  //             p="10px"
  //             display="flex"
  //             flexDirection="column"
  //             overflow="hidden"
  //           >
  //             <DeprecatedDatasetList />
  //           </Box>
  //         </GridItem>
  //       </Grid>
  //     </Box>
  //   );
  // }

  // Non-Publisher Layout (Default)
  return (
    <Box h="100%" w="100%" bgColor={"#f6f3ec"} overflow={"auto"}>
      <Grid
        templateRows='repeat(3, 1fr)'
        templateColumns='repeat(4, 1fr)'
        h='100%'
        w='98%'
        gap="2"
        margin={2}
      >
        <GridItem colSpan={2} p={"10px"} borderWidth={2} borderColor={"#0888BE"} borderRadius={"20px"} bgColor={"#f6f3ec"}>
          <Dataset />
        </GridItem>
        <GridItem colSpan={2} p={"10px"} borderWidth={2} borderColor={"#0888BE"} borderRadius={"20px"} bgColor={"#f6f3ec"}>
          <DatasetOttenuti />
        </GridItem>
        <GridItem colSpan={2} p={"10px"} borderWidth={2} borderColor={"#0888BE"} borderRadius={"20px"} bgColor={"#f6f3ec"}>
          <StagingArea />
        </GridItem>
        <GridItem colSpan={2} p={"10px"} borderWidth={2} borderColor={"#0888BE"} borderRadius={"20px"} bgColor={"#f6f3ec"}>
          <DatasetPubblici />
        </GridItem>
        <GridItem colSpan={2} p={"10px"} borderWidth={2} borderColor={"#0888BE"} borderRadius={"20px"} bgColor={"#f6f3ec"}>
          <Elaborazioni />
        </GridItem>
        <GridItem colSpan={2} p={"10px"} borderWidth={2} borderColor={"#0888BE"} borderRadius={"20px"} bgColor={"#f6f3ec"}>
          <Risultati />
        </GridItem>
        {/* Spacer row to push bottom margin */}
        <GridItem colSpan={4}>
          <Box h="2px" />
        </GridItem>
      </Grid>
    </Box>
  );
}